import controller from './vd-suggestion.controller'

export default {
  bindings: {
    suggestion: '<',
    source: '<',
    query: '<',
  },
  controller,
}
